export default [
    'To be filled-in',
    'To be corrected',
    'To be approved',
    '',
    'Completed',
    'Processing not applicable'
]